import React from "react";
import { Moon, Sun, Monitor } from "lucide-react";
import {
  ToggleGroup,
  ToggleGroupItem
} from "@/components/ui/toggle-group";
import { useTheme } from "@/components/ThemeProvider";

export function ThemeToggle({ showLabel = false }: { showLabel?: boolean }) {
  const { theme, setTheme } = useTheme();

  return (
    <div className="flex flex-col gap-1.5">
      {showLabel && <div className="text-xs font-medium text-muted-foreground">Theme Preference</div>}
      <ToggleGroup type="single" value={theme} onValueChange={(value) => value && setTheme(value as "light" | "dark" | "system")}>
        <ToggleGroupItem value="light" aria-label="Light theme" className="flex-1 px-2 py-1.5">
          <Sun className="h-4 w-4 mr-1.5" />
          <span className="text-xs">Light</span>
        </ToggleGroupItem>
        <ToggleGroupItem value="dark" aria-label="Dark theme" className="flex-1 px-2 py-1.5">
          <Moon className="h-4 w-4 mr-1.5" />
          <span className="text-xs">Dark</span>
        </ToggleGroupItem>
        <ToggleGroupItem value="system" aria-label="System theme" className="flex-1 px-2 py-1.5">
          <Monitor className="h-4 w-4 mr-1.5" />
          <span className="text-xs">Auto</span>
        </ToggleGroupItem>
      </ToggleGroup>
    </div>
  );
}